import type { CSSProperties } from 'react';
import { ICON_REGISTRY } from '../../components/surface/content/icon-registry';

interface ButtonProps {
  label: string;
  variant?: 'primary' | 'secondary' | 'ghost';
  icon?: string;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
}

const VARIANT_CLASSES: Record<string, string> = {
  primary: 'bg-blue-600 text-white hover:bg-blue-700 disabled:bg-blue-300',
  secondary: 'bg-zinc-200 text-zinc-800 hover:bg-zinc-300 dark:bg-zinc-700 dark:text-zinc-200',
  ghost: 'text-zinc-600 hover:bg-zinc-100 dark:text-zinc-400 dark:hover:bg-zinc-800',
};

export function ButtonView({
  label,
  variant = 'primary',
  icon,
  disabled = false,
  className,
  style,
}: ButtonProps) {
  const IconComponent = icon ? ICON_REGISTRY[icon] : null;
  return (
    <button
      disabled={disabled}
      className={`inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary}${className ? ` ${className}` : ''}`}
      style={style}
    >
      {IconComponent && <IconComponent className="h-4 w-4" />}
      {label}
    </button>
  );
}
